import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// import * as Cookies from 'js-cookie';
// import axios from 'axios';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import modules from './modules';

Vue.use(Vuex);

//Used in local storage
const userProfileState = createPersistedState({
  paths: ['authentication', 'brand']
});

export default new Vuex.Store({
  state: {
    defaultLanguage: 'en',
    navDrawerOpen: false,
    ksStatus: null,
    impersonating: false
  },

  actions: {
    ...actions,

    resetAllState({ dispatch }) {
      for (const currentModule in modules) {
        dispatch('resetModuleState', currentModule);
      }
    },
    resetModuleState: (/* { commit }, currentModule */) => {
      // const initialState = modules[currentModule].state;
      // Object.keys(initialState).forEach(key => {
      //   commit(`${currentModule}/SET_${key.toUpperCase()}`, initialState[key]);
      // });
    }
  },
  mutations,
  getters,
  modules,
  plugins: [userProfileState]
});
